import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Scorecard, ScorecardQuery, ScorecardService } from '@fgb/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { ScorecardDescriptionComponent } from '../../scorecard-description/scorecard-description.component';
import { Router } from '@angular/router';

@Component({
  selector: 'fgbcl-scorecard-number-view',
  templateUrl: './scorecard-number-view.component.html',
  styleUrls: ['./scorecard-number-view.component.scss', '../scorecard-display-shared.scss'],
})
export class ScorecardNumberViewComponent implements OnInit {
  @Input() scorecard: Scorecard;
  @Input() confettiColors: string[];
  @Input() icon: string = 'info';
  @Input() disabled: boolean = false;
  preventMultipleClick: boolean = false;
  isOpenModal: boolean = true;
  isScorecardHasChild: boolean = false;
  @Input() isSponsorInBody: boolean = false;
  constructor(
    private offcanvasService: NgbOffcanvas,
    private router: Router,
    private scorecardService: ScorecardService,
    private scorecardQuery: ScorecardQuery
  ) {}

  ngOnInit() {
    this.isScorecardHasChild = this.scorecardQuery.hasLinkedScorecards(this.scorecard.ScorecardId);
    this.onWindowResize(window.innerWidth);
  }

  @HostListener('window:resize', ['$event.target.screen.width'])
  onWindowResize(event: number) {
    if (event > 576) {
      this.isOpenModal = true;
    } else {
      this.isOpenModal = false;
    }
  }

  openScorecardDescription() {
    if (!this.disabled) {
      this.isOpenModal ? this.openModal() : this.redirectComponent();
    }
  }

  openModal() {
    const offcanvasRef = this.offcanvasService.open(ScorecardDescriptionComponent, {
      position: 'bottom',
      panelClass: 'scorecard-offcanvas-content',
    });
    offcanvasRef.componentInstance.confettiColors = this.confettiColors;
    offcanvasRef.componentInstance.scorecardId = this.scorecard.ScorecardId;
    offcanvasRef.componentInstance.isSponsorInBody = this.isSponsorInBody;
  }

  redirectComponent() {
    const initVal = {
      confettiColors: this.confettiColors,
    };
    let params = this.isSponsorInBody ? { isSponsorInBody: this.isSponsorInBody } : {};

    this.scorecardService.initDataScorecardDescription$.next(initVal);
    this.router.navigate(['/scorecard-description', this.scorecard.ScorecardId, params]);
  }
}
